import type { ReactNode } from 'react';

import type { StylesProps } from '../types';

/**
 * Styles setting for customizing row, cell, and header styles.
 *
 * @example
 * ```tsx
 * <DataTable.Styles
 *   row={{
 *     base: 'bg-neutral-900',
 *     hovered: 'bg-neutral-700',
 *     selected: 'bg-neutral-600',
 *   }}
 *   cell={{
 *     base: 'border-b border-border',
 *   }}
 *   header={{
 *     base: 'bg-muted',
 *     sorted: 'text-primary',
 *   }}
 * />
 * ```
 */
export const Styles = (_props: StylesProps): ReactNode => {
  return null;
};

Styles.displayName = 'DataTable.Styles';
